(function (Drupal, once) {
  Drupal.behaviors.devLog = {
    attach: function (context, settings) {
      once('devLogBehavior', 'html', context).forEach(() => {
        const {drupalSettings} = window || false;
        if (drupalSettings) {
          const {environment} = drupalSettings;
          initEnvironment(environment);
        }
      });
    }
  };

  let envIsProdOrStage = false;

  function initEnvironment(environment) {
    envIsProdOrStage = (environment === 'prod' || environment === 'test');
  }

  function isProdOrStage() {
    return envIsProdOrStage;
  }

  /**
   * Wrapper for console logging in development.
   * @param  {...any} messages Passed directly to console.log
   */
  window.devLog = function (...messages) {
    if (!isProdOrStage()) {
      console.log(...messages); // eslint-disable-line no-console
    }
  };

  /**
   * Wrapper for console warnings in development.
   * @param  {...any} messages Passed directly to console.warn
   */
  window.devWarn = function (...messages) {
    if (!isProdOrStage()) {
      console.warn(...messages); // eslint-disable-line no-console
    }
  };

  /**
   * Wrapper for console errors in development.
   * @param  {...any} messages Passed directly to console.error
   */
  window.devError = function (...messages) {
    if (!isProdOrStage()) {
      console.error(...messages); // eslint-disable-line no-console
    }
  };

})(Drupal, once);
